export default __webpack_public_path__ + "static/media/deleteRed.3eaf9933.svg";